export default (isDraft, published) => !isDraft && published
